var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFinanceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4767 23.78L23.5351 29.8017L22.4817 29.4917L23.3451 27.3783C24.1034 25.6867 23.3368 23.7017 21.6367 22.96L11.8584 18.7C11.2817 18.4683 10.6584 18.3333 10.0001 18.3333C9.51508 18.3333 9.05675 18.4233 8.61341 18.5517L1.66675 20.1783V32.18L8.33342 30L21.9267 34.7567C22.3684 34.9117 22.8284 34.9883 23.2851 34.9883C23.9551 34.9883 24.6217 34.825 25.2251 34.5017L37.4367 27.9733L35.4767 23.78ZM20.2801 26.065L20.2584 26.1167L19.3951 28.23L18.6418 30.0733L9.43341 26.8517L8.36841 26.48L7.29675 26.83L5.00008 27.5833V22.8217L9.37341 21.7983L9.45842 21.7783L9.54175 21.7533C9.74175 21.6967 9.89508 21.6667 10.0001 21.6667C10.1901 21.6667 10.3851 21.705 10.5817 21.7783L20.3034 26.0133L20.2801 26.065ZM28.3334 5C24.6517 5 21.6667 7.985 21.6667 11.6667C21.6667 15.3483 24.6517 18.3333 28.3334 18.3333C32.0151 18.3333 35.0001 15.3483 35.0001 11.6667C35.0001 7.985 32.0151 5 28.3334 5ZM28.3334 15C26.4917 15 25.0001 13.5083 25.0001 11.6667C25.0001 9.825 26.4917 8.33333 28.3334 8.33333C30.1751 8.33333 31.6667 9.825 31.6667 11.6667C31.6667 13.5083 30.1751 15 28.3334 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFinanceActive);
export default __webpack_public_path__ + "static/media/ic-finance-active.bec38c89.svg";
export { ForwardRef as ReactComponent };